export const homePageImg = "/images/Man-with-Talent.jpg";
export const errorPageImg = "/images/beer.jpg";